var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
/** @author: Richard 16/3/2018
 *  @desc: BreakWord for all browsers.
    - break-all (Supported by all)
    - -ms-* for IE
    - break-word for proper browsers
 */
export var breakWord = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -ms-word-wrap: break-word;\n  word-break: break-word;\n"], ["\n  -ms-word-wrap: break-word;\n  word-break: break-word;\n"])));
export default {
    breakWord: breakWord
};
var templateObject_1;
